import React from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { MAX_DROPDOWN_HEIGHT } from "../../types/micellinous-constants";

function OutcomeFilter({ selectedOutcome, setSelectedOutcome }) {
  const handleOutcomeChange = (event) => {
    setSelectedOutcome(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="outcome-select-label">Outcome</InputLabel>
      <Select
        labelId="outcome-select-label"
        id="outcome-select"
        value={selectedOutcome}
        onChange={handleOutcomeChange}
        MenuProps={{
          style: {
            maxHeight: MAX_DROPDOWN_HEIGHT,
          },
        }}
      >
        <MenuItem value="All">All</MenuItem>

        <MenuItem value="wash">Wash</MenuItem>
        <MenuItem value="rub">Rub</MenuItem>
        <MenuItem value="missed">Missed</MenuItem>
      </Select>
    </FormControl>
  );
}

export default OutcomeFilter;
